import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { injectIntl } from 'react-intl';

import FileAccess from './Access';
import FileDate from './Date';
import FileExtension from './Extension';
import FileResolution from './Resolution';
import FileSize from './Size';
import FileEditableStatus from './EditableStatus';
import FileCustomFields from './CustomFields';
import FileViews from './Views';
import FileOriginalName from './OriginalName';
import FileUuid from './Uuid';
import FileEditableField from './EditableField';
import FileNameEditableField from './NameEditableField';
import FileOpenInFigma from './OpenInFigma';
import TrashRemainingDays from '../TrashRemainingDays';

import { userCan } from '../../helpers/Auth';
import { getSetting } from '../../helpers/Settings';

class FileGeneralInfo extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      collapse: true,
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    const { collapse } = this.state;
    this.setState({ collapse: !collapse });
  }

  render() {
    const {
      intl,
      file,
      fileEdition,
      fileVersion,
      fileViews,
      shareUuid,
      showEmptyCustomFields,
      handleFileEdition,
      readOnly,
    } = this.props;

    return (
      <div className="file-general-info file-details-item">
        <div className="file-detail-body">
          <h5 className="file-name">
            {file.type === 'link' ? (
              <a href={file.path} title={file.display_name} target="_blank" rel="noopener noreferrer">
                <i className="fas fa-link-horizontal" />{' '}
                {file.display_name}
              </a>
            ) : (
              <FileNameEditableField
                file={file}
                field="name"
                required={true}
                readOnly={readOnly}
              />
            )}
          </h5>
          <div className="file-details-wrapper">
            <div className="file-details">
              <div>
                {(
                  !shareUuid &&
                  !(
                    userCan('file.change_access', file) &&
                    (file.parent || file.parent_uuid) &&
                    file.searchable === false
                  )
                ) && (
                  <FileAccess
                    file={file}
                    callbackUpdate={fileEdition ? handleFileEdition : () => {}}
                  />
                )}
                <FileResolution
                  file={file}
                />
                <FileExtension
                  file={file}
                />
                <FileSize
                  file={file}
                />
              </div>
            </div>
            <div>
              {(
                !shareUuid &&
                userCan('file.change_access', file) &&
                (file.parent || file.parent_uuid) &&
                file.searchable === false
              ) && (
                <FileAccess
                  file={file}
                  callbackUpdate={fileEdition ? handleFileEdition : () => {}}
                />
              )}
              <TrashRemainingDays
                file={file}
              />
            </div>
          </div>
          <div className="file-status-wrapper">
            <FileEditableStatus
              file={file}
              readOnly={readOnly}
            />
          </div>
          {getSetting('expiration_date') && (
            <div className={classnames('file-expiration-date', { 'file-expired': file.expired })}>
              <FileEditableField
                file={file}
                fieldType="date"
                field="expires_at"
                fieldName="expiration date"
                fieldPrefix={
                      file.expired ?
                        `<i class="fa-solid fa-timer"></i> ${intl.formatMessage({ defaultMessage: 'Expired on: ' })} ` :
                        `<i class="fa-solid fa-timer"></i> ${intl.formatMessage({ defaultMessage: 'Expires on: ' })} `
                    }
                fieldValue={file.expires_at}
                readOnly={readOnly}
              />
            </div>
          )}
          <div className="file-details">
            <div>
              <FileViews fileViews={fileViews} />
              <FileOriginalName
                file={file}
              />
              <FileUuid
                file={file}
              />
            </div>
          </div>
          <div className="file-details">
            <div>
              <FileDate
                file={file}
                fileVersion={fileVersion}
              />
            </div>
          </div>
          <div className="file-details">
            <div>
              <FileOpenInFigma
                file={file}
                fileVersion={fileVersion}
              />
            </div>
          </div>
          <div className="file-description file-textarea">
            <FileEditableField
              file={file}
              fieldType="textarea"
              field="description"
              fieldValue={file.description}
              readOnly={readOnly}
            />
          </div>
          <FileCustomFields
            file={file}
            showEmptyCustomFields={showEmptyCustomFields}
            readOnly={readOnly}
          />
        </div>
      </div>
    );
  }
}

FileGeneralInfo.propTypes = {
  intl: PropTypes.object.isRequired,
  file: PropTypes.object.isRequired,
  showEmptyCustomFields: PropTypes.bool.isRequired,
  fileEdition: PropTypes.object,
  handleFileEdition: PropTypes.func,
  fileVersion: PropTypes.number,
  fileViews: PropTypes.number,
  shareUuid: PropTypes.string,
  readOnly: PropTypes.bool,
};

FileGeneralInfo.defaultProps = {
  shareUuid: '',
  fileEdition: null,
  fileVersion: null,
  fileViews: null,
  readOnly: false,
  handleFileEdition: () => {},
};

export default injectIntl(connect()(FileGeneralInfo));
